if (!window.customElements.get('rewards-tier-card')) {
  class RewardsTierCard extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buildSection();

      this.currentTier = this.querySelector('[data-tier-current]');
      this.message = this.querySelector('[data-tier-message]');
      this.badge = this.querySelector('[data-tier-badge]');

      if (!this.currentTier || !this.message || !this.badge) return;

      this.getTiers();
    }

    buildSection() {
      this.innerHTML = `
        <div class="${window.location.href.indexOf('/tools/recurring') >= 0 ? 'w-[calc(100%+40px)] -ml-5 px-5 lg:px-6 pt-5.25 pb-6 lg:py-6 bg-white lg:ml-0 lg:w-full lg:rounded-2xl' : 'block max-w-190 mt-8 mx-auto p-6 rounded-xl border border-base-neutral-300 bg-white'}">
          <div class="flex items-start justify-between gap-4 mb-6">
            <div>
              <p class="accent-base">
                ${window.ehs.strings.rewards.tierCard.heading}
              </p>

              <strong class="heading-md" data-tier-current>-</strong>
            </div>

            <div
              class="w-12 h-12 flex items-center justify-center text-charcoal-green-800"
              data-tier-badge
              aria-hidden="true"
            >
              <span data-tier-icon="sous-chef" class="hidden">
                <svg class="size-12" aria-label="Sous Chef Badge" fill="none" viewBox="0 0 638 792" xmlns="http://www.w3.org/2000/svg">
                  <path d="M146 536 68 697c-2 3 1 6 4 6l110-36c4-1 8 1 10 5l38 109c1 2 4 2 5 0l89-185-98-15-80-45Z" fill="#BC8561"/>
                  <path d="m502 540 76 157c2 3-1 6-4 6l-110-36c-4-1-8 1-10 5l-38 109c-1 2-4 2-5 0l-89-185 98-15 82-41Z" fill="#BC8561"/>
                  <path d="M158 535 83 689l98-32c8-3 16 2 20 10l33 94 84-172-88-13-72-41Zm333 4 72 149-97-31c-8-3-17 2-21 10l-33 94-82-171 87-14 74-37Z" stroke="#8E5B3F" stroke-miterlimit="10" stroke-width="7.8"/>
                  <path d="M317 608a297 297 0 1 0 0-594 297 297 0 0 0 0 594Z" fill="url(#tier-one-gradient)"/>
                  <path d="M188 453c0 5-4 8-8 8s-9-3-9-8 4-8 9-8 8 3 8 8Zm262-8c-5 0-9 3-9 8s4 8 9 8 8-3 8-8-4-8-8-8Zm38 26-19 19c-10 9-23 9-32 0l-79-80c-16-15-13-23-13-23l-24 19-19-22-6 7c1 8 0 15-5 20l-92 81c-10 8-29 6-38-4l-19-22c-9-10-8-25 2-33l92-81c4-4 13-8 21-6l26-23c-55-16-68-19-70-21l-74-74c-7-7-5-21 2-28l57-57c7-7 18-7 25 0l74 74c2 2 7 10 24 68l3 2 171-154s34 78-109 216l3 4c1 0 11-2 19 6l80 80c9 9 9 23 0 32ZM290 310l4 4 19-17-11-9-21-66-67-67c-1-2-3-1-5 0l-56 57c-2 1-2 3 0 5l72 72c5 3 65 21 65 21Zm-11 74-19-22s-3-4-11 3l-92 81c-4 3-4 10-1 14l15 19c5 5 11 4 14 1l92-81c6-6 4-12 2-15Zm202-212L272 355l17 20 17-15 25 25c120-108 147-182 153-213h-3ZM358 378l18-19-3-2-18 17 3 4Zm120 71-76-77c-3-3-9-4-12-1l-20 20c-2 2-3 7 1 11l76 78c3 2 8 4 12 0l19-19c3-3 3-9 0-12ZM215 168c-3-2-7-2-10 0s-2 7 0 10l61 61c3 2 7 2 10 0s2-7 0-10l-61-61Zm-39 39c-3-2-7-2-10 0s-2 7 0 10l61 61c3 2 7 2 10 0s2-7 0-10l-61-61Zm20-19c-3-3-7-3-10 0s-3 7 0 10l60 60c3 3 7 3 10 0s3-7 0-10l-60-60Z" fill="#8E5B3F"/>
                  <path d="M190 443c0 4-4 8-9 8s-8-4-8-8 3-9 8-9 8 4 8 9h1Zm261-9c-4 0-8 4-8 8s4 9 8 9 9-4 9-8-4-9-9-9Zm38 26-18 19c-10 10-23 9-32 0l-80-79c-5-6-7-13-6-20l-7-6-21 18-19-22-10 9c1 7-2 15-8 20l-92 81c-9 8-24 8-34-2l-19-22c-8-10-7-25 3-34l92-81c4-4 12-7 20-5l27-24c-55-16-66-22-68-24l-74-74c-7-6-7-18 0-25l56-56c7-7 19-7 25 0l75 74c1 1 6 9 24 67l2 3 170-149s20 74-111 208l7 7c1 0 10-2 19 6l79 80c9 8 9 23 0 31ZM292 300l3 3 19-17-4-4s-19-61-22-66l-74-73c-1-2-3-1-5 0l-56 57c-2 1-2 3 0 5l73 73c5 3 66 22 66 22Zm-12 74-19-22s-6-7-14 0l-92 81c-4 3-5 10-1 14l19 21c4 5 10 4 14 1l92-81c5-5 3-12 1-14Zm200-215L272 343l19 22 17-15 19 22c120-107 147-182 153-213ZM359 367l18-18-2-3-19 18 3 3Zm120 72-79-80c-3-3-9-4-12-1l-20 20c-2 2-3 8 1 12l80 79c2 3 7 4 12 0l18-19c4-3 4-8 0-11ZM216 158c-2-3-7-3-9 0s-3 7 0 10l60 60c3 3 7 3 10 0s3-7 0-10l-61-60Zm-39 39c-2-3-7-3-9 0s-3 7 0 10l60 60c3 3 7 3 10 0s3-7 0-10l-61-60Zm20-20c-3-2-7-2-10 0s-2 7 0 10l61 61c3 2 7 2 10 0s2-7 0-10l-61-61Z" fill="#fff"/>
                  <path d="M317 582a271 271 0 1 0 0-543 271 271 0 0 0 0 543Z" stroke="#8E5B3F" stroke-miterlimit="10" stroke-width="9.5"/>
                  <defs>
                    <linearGradient id="tier-one-gradient" x1="96.9" x2="560.4" y1="537.5" y2="59" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#9B6749"/>
                      <stop offset=".2" stop-color="#A67151"/>
                      <stop offset=".5" stop-color="#DAAD96"/>
                      <stop offset=".7" stop-color="#BB8460"/>
                      <stop offset=".8" stop-color="#AD7755"/>
                      <stop offset=".9" stop-color="#966245"/>
                      <stop offset="1" stop-color="#8E5B3F"/>
                    </linearGradient>
                  </defs>
                </svg>
              </span>

              <span data-tier-icon="head-chef" class="hidden">
                <svg class="size-12" aria-label="Head Chef Badge" fill="none" viewBox="0 0 636 789" xmlns="http://www.w3.org/2000/svg">
                  <path d="M145 534 68 694c-2 3 1 6 4 6l109-36c4-1 9 2 10 5l38 108c1 2 4 3 5 1l89-184-98-15-80-45Z" fill="#999"/>
                  <path d="m500 537 76 157c1 3-1 6-4 6l-110-36c-4-1-8 2-10 5l-38 108c-1 2-4 3-5 1l-88-184 97-15 82-42Z" fill="#999"/>
                  <path d="M158 533 84 685l96-31c9-3 18 1 21 10l31 91 84-170-87-11-71-41Zm331 4 72 149-98-31c-8-3-16 1-19 9l-34 94-81-171 87-13 73-37Z" stroke="#747575" stroke-miterlimit="10" stroke-width="7.8"/>
                  <path d="M319 605a297 297 0 1 0 0-594 297 297 0 0 0 0 594Z" fill="url(#tier-two-gradient)"/>
                  <path d="M162 380c-9 0-18-1-27-4-15-5-26-16-31-29-4-13-1-31 12-41-6-16 0-34 9-46 8-11 18-18 28-25l8-6 29-26 23-20c23-19 44-29 64-31l33 3c12 2 24 4 35 3 7-1 13-4 20-6 12-4 25-9 38-5 14 3 24 13 34 24l12 11c8 8 19 13 28 19 19 11 38 21 48 43 10 24 6 60-14 83-15 18-43 42-70 48l-4-13c23-6 49-27 64-45 17-20 22-47 13-67-8-19-25-28-42-38-16-8-30-19-43-32-9-10-17-19-28-22-11-2-22 2-33 6l-21 6c-13 2-27 0-39-2-11-2-21-4-31-3-18 1-35 14-56 31l-23 20-30 27-9 6c-9 7-19 11-26 20-8 11-13 24-6 36l1 3-3 4c-12 7-15 21-11 32 3 10 12 19 24 23 11 3 24 3 35 3 12-1 21-3 26-10l8 6c-7 11-20 13-33 14h-12Z" fill="#666" stroke="#666" stroke-miterlimit="10" stroke-width="3.2"/>
                  <path d="m377 344-10-4c14-32 23-65 29-100l3-2 6 1 1 2c-5 35-15 70-29 103Zm-85-3c-14-36-16-83-13-114 1-2 2-3 4-3l7 1c-4 32 2 79 15 113l-13 3Zm-45 9c-31-19-49-34-64-70-2-2 0-3 1-4l7-2c14 34 31 49 61 67l-5 9Zm-30 9c-29 0-54-7-70-18v-5l4-6c14 12 38 19 66 19v10Zm205-5-6-8c14-10 28-20 40-32 13-13 20-25 22-39l7 1c2 0 3 2 3 4-4 15-11 28-25 42-12 12-26 23-41 32Z" fill="#666" stroke="#666" stroke-miterlimit="10" stroke-width="3.2"/>
                  <path d="M429 469c-72-21-148-20-220 2-3 1-7 1-10-1s-4-6-4-9v-93c0-10 15-19 41-25 22-5 52-8 84-8s62 2 85 8c26 6 38 13 38 24v92c0 3-2 6-4 8s-4 2-7 2h-3Zm-109-29c54 0 100 14 112 18h1l-3-1v-90c0-1-3-7-28-13-54-12-111-11-165 1-25 6-31 16-31 17l1 85 1 1c13-4 58-18 112-18Z" fill="#666" stroke="#666" stroke-miterlimit="10" stroke-width="3.2"/>
                  <path d="M433 397s-3-6-33-12c-53-8-107-8-160 2-30 5-33 15-33 15l-10-6c0-7 9-12 12-13 73-17 148-17 221 0 4 1 13 6 13 14h-10Z" fill="#666" stroke="#666" stroke-miterlimit="10" stroke-width="3.2"/>
                  <path d="M319 580a271 271 0 1 0 0-543 271 271 0 0 0 0 543Z" stroke="#747575" stroke-miterlimit="10" stroke-width="9.5"/>
                  <defs>
                    <linearGradient id="tier-two-gradient" x1="149.8" x2="603.8" y1="503.6" y2="-21.9" gradientUnits="userSpaceOnUse">
                      <stop stop-color="gray"/>
                      <stop offset=".4" stop-color="#CCC"/>
                      <stop offset=".9" stop-color="gray"/>
                    </linearGradient>
                  </defs>
                </svg>
              </span>

              <span data-tier-icon="executive-chef" class="hidden">
                <svg class="size-12" aria-label="Executive Chef Badge" fill="none" viewBox="0 0 635 788" xmlns="http://www.w3.org/2000/svg">
                  <path d="M145 533 68 694c-2 2 1 6 4 5l109-35c4-1 8 1 10 5l38 108c1 1 4 2 5 0l88-184-97-15-80-45Z" fill="#C19846"/>
                  <path d="m500 537 75 157c2 2-1 6-4 5l-109-35c-5-1-9 1-11 5l-38 108c0 1-3 2-4 0l-89-184 97-15 82-41h1Z" fill="#C19846"/>
                  <path d="M156 533 83 684l96-30c8-3 18 1 21 10l33 92 82-170-87-13-72-40Zm331 1 75 152-98-31c-8-3-17 1-20 10l-34 91-83-170 87-13 73-39Z" stroke="#A77A2D" stroke-miterlimit="10" stroke-width="7.8"/>
                  <path d="M321 605a297 297 0 1 0 0-594 297 297 0 0 0 0 594Z" fill="url(#tier-three-gradient)"/>
                  <path d="M179 177c15-10 57-29 78-38 6 11 21 30 58 30h14l-1-12h-12c-41 0-50-28-51-29l-7-7c1 7-70 33-87 47l-7 5c1 2 21 49 31 290 0 3 4 5 7 5h4c2 0 3-1 2-3-5-211-25-266-30-288h1Z" fill="#A77A2D" stroke="#A77A2D" stroke-miterlimit="10" stroke-width="7.8"/>
                  <path d="m473 173 1-3-3-3c-17-14-88-42-91-43l-6-2-2 6s-10 29-50 29v12c41 1 56-18 62-29 21 9 59 22 74 33-5 23-33 39-33 296 0 3 4 6 6 6l6-1c2 0 2-1 2-2 2-282 33-297 34-299ZM177 445c-34 0-64-10-66-10l-2-1h-2v-4c-10-141 43-256 60-260l5 6c-1 2-56 97-52 250 12 3 47 11 81 6l2 11c-9 2-17 2-26 2Z" fill="#A77A2D" stroke="#A77A2D" stroke-miterlimit="10" stroke-width="7.8"/>
                  <path d="M169 398c-30 0-55-9-56-10l4-11c0 1 43 17 81 6l4 11c-11 3-22 4-33 4Zm290 47c-8 0-16 0-25-2l2-11c34 5 65-2 77-6 4-152-50-246-50-247l12-8c0 2 59 103 53 259v4l-4 2c-1 0-30 9-65 9Z" fill="#A77A2D" stroke="#A77A2D" stroke-miterlimit="10" stroke-width="7.8"/>
                  <path d="M467 398c-10 0-21-1-32-4l3-11c39 11 82-5 82-6l4 11c-1 1-26 10-57 10ZM281 225c-6 0-10-5-10-10s4-11 10-11 10 5 10 11-4 10-10 10Zm0-12-1 1c0 2 3 2 3 1l-2-2Zm77 12c-6 0-10-5-10-10s4-11 10-11 10 5 10 11-5 10-10 10Zm0-12-2 1c0 2 3 2 3 1l-1-2Zm-77 95c-6 0-10-4-10-10s4-10 10-10 10 4 10 10-4 10-10 10Zm0-11-1 1c0 2 3 2 3 0s-1-1-2-1Zm77 11c-6 0-10-4-10-10s4-10 10-10 10 4 10 10-5 10-10 10Zm0-11-2 1c0 2 3 2 3 0s0-1-1-1Zm-77 104c-6 0-10-5-10-11s4-10 10-10a10 10 0 0 1 0 20v1Zm0-12-1 1c0 2 3 2 3 0s-1-1-2-1Zm77 12c-6 0-10-5-10-11s4-10 10-10 10 5 10 10-5 10-10 10v1Zm0-12-2 1c0 2 3 2 3 0s0-1-1-1ZM253 131c0-1-3-8 2-15 8-12 30-19 67-19v12c-41 3-51 12-53 16-2 2-3 1-5 1l-11 5Z" fill="#A77A2D" stroke="#A77A2D" stroke-miterlimit="10" stroke-width="7.8"/>
                  <path d="m384 131-10-5-1-4c-3-4-14-13-58-13V98c37 0 60 6 68 18 5 7 2 14 1 15Z" fill="#A77A2D" stroke="#A77A2D" stroke-miterlimit="10" stroke-width="7.8"/>
                  <path d="M321 579a271 271 0 1 0 0-543 271 271 0 0 0 0 543Z" stroke="#A77A2D" stroke-miterlimit="10" stroke-width="9.5"/>
                  <defs>
                    <linearGradient id="tier-three-gradient" x1="183.4" x2="451.2" y1="497.1" y2="128.5" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#C19846"/>
                      <stop offset=".2" stop-color="#C39B48"/>
                      <stop offset=".4" stop-color="#CBA550"/>
                      <stop offset=".6" stop-color="#DBB960"/>
                      <stop offset=".7" stop-color="#D0AB55"/>
                      <stop offset=".9" stop-color="#C49C49"/>
                      <stop offset="1" stop-color="#C19846"/>
                    </linearGradient>
                  </defs>
                </svg>
              </span>
            </div>
          </div>

          <p class="text-sm" data-tier-message>
            ${window.ehs.strings.rewards.tierCard.heading}
          </p>

          <a
            class="button button--alt tracking-normal text-white! max-w-none w-full lg:w-auto normal-case text-[16px] px-4.75 mt-4"
            href="${window.ehs.rewards.tiersLink}"
          >
            ${window.ehs.strings.rewards.tierCard.learnMore}

            <svg class="size-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.92443 1.5L8.51136 2.8799L12.3535 7.00156L-6.56054e-08 7.00156L-6.6153e-08 9.00053L12.3717 9.00053L8.51329 13.116L9.9225 14.5L16 8.01756L9.92443 1.5Z" fill="currentColor"/>
            </svg>
          </a>
        </div>
      `;
    }

    getTiers() {
      this.waitForStore(30, 100)
        .then((store) => {
          return store.waitForReady(30, 100);
        })
        .then((store) => {
          if (typeof store.fetch === 'function') {
            return store.fetch();
          }
          return Promise.reject(new Error('AntavoPointsStore fetch unavailable'));
        })
        .then((payload) => {
          const tier = this.extractTier(payload);

          if (!tier) {
            this.renderFallback();
            return;
          }

          this.renderTier(tier);
        })
        .catch(() => {
          this.renderFallback();
        });
    }

    extractTier(payload) {
      if (!payload || typeof payload !== 'object') return null;

      if (!payload?.properties?.current_tier) return null;

      return {
        currentTier: payload?.properties?.current_tier,
        nextTier: payload?.properties?.next_tier,
        requiredOrdersForPromotion: payload?.properties?.progression_needed_for_next_tier,
      };
    }

    getVariant(tier) {
      if (tier.currentTier === 'None') return 'no-tier';
      if (tier.currentTier === 'Executive Chef') return 'highest-tier';
      if (tier.nextTier === 'Executive Chef') return 'second-highest-tier';
      return 'lower-tier';
    }

    getMessage(tier, variant) {
      const required = tier.requiredOrdersForPromotion;
      const nextTier = tier.nextTier;

      if (variant !== 'highest-tier' && (!required || required < 1)) {
        return window.ehs.strings.rewards.tierCard.keepOrdering;
      }

      if (variant === 'highest-tier') {
        return window.ehs.strings.rewards.tierCard.topTier;
      }

      if (variant === 'second-highest-tier') {
        return window.ehs.strings.rewards.tierCard.secondHighestTier.replace('[count]', required).replace('[tier_name]', nextTier);
      }

      if (variant === 'no-tier') {
        return window.ehs.strings.rewards.tierCard.noTier.replace('[tier_name]', nextTier);
      }

      return window.ehs.strings.rewards.tierCard.nextTier.replace('[count]', required).replace('[tier_name]', nextTier);
    }

    setBadgeForTier(currentTier) {
      let icon = 'none';

      if (currentTier === 'Executive Chef') icon = 'executive-chef';
      else if (currentTier === 'Head Chef') icon = 'head-chef';
      else if (currentTier === 'Sous Chef') icon = 'sous-chef';

      const iconEls = this.badge.querySelectorAll('[data-tier-icon]');

      for (var i = 0; i < iconEls.length; i += 1) {
        iconEls[i].classList.add('hidden');

        if (iconEls[i].getAttribute('data-tier-icon') === icon) {
          iconEls[i].classList.remove('hidden');
        }
      }
    }

    renderTier(tier) {
      const variant = this.getVariant(tier);
      this.currentTier.textContent = variant === 'no-tier' ? '-' : tier.currentTier;
      this.message.innerHTML = this.getMessage(tier, variant);
      this.setBadgeForTier(tier.currentTier);
    }

    renderFallback() {
      this.renderTier({
        currentTier: 'None',
        nextTier: 'Sous Chef',
        requiredOrdersForPromotion: 1,
      });
    }

    waitForStore(maxAttempts, delayMs) {
      return new Promise(function (resolve, reject) {
        let attempts = 0;

        function check() {
          const store = window.AntavoPointsStore;

          if (store && typeof store.waitForReady === 'function') {
            resolve(store);
            return;
          }

          attempts += 1;

          if (attempts >= maxAttempts) {
            reject(new Error('AntavoPointsStore unavailable'));
            return;
          }

          setTimeout(check, delayMs);
        }

        check();
      });
    }
  }

  window.customElements.define('rewards-tier-card', RewardsTierCard);
}
